'use client';

import { type FC, useMemo } from 'react';
import { usePathname, useParams } from 'next/navigation';
import { LeftNavItem, type LeftNavItemProps } from '@/_components/LeftNavItem';

export const ClientDashboardNav: FC = () => {
  const path = usePathname();
  const { userId } = useParams();

  const items: Array<LeftNavItemProps> = useMemo(
    () => [
      {
        name: 'Overview',
        icon: 'dashboard',
        href: '/',
        isActive: false,
      },
      {
        isSeparator: true,
      },
      {
        name: 'Back to Users',
        icon: 'arrow-left',
        href: '/clients',
        isActive: false,
      },
      {
        isSeparator: true,
      },
      {
        name: 'Dashboard',
        icon: 'user-circle-gear',
        href: `/clients/${userId}`,
        isActive: path === `/clients/${userId}`,
      },
    ],
    [path, userId],
  );

  return (
    <>
      {items.map((item, key) => (
        <LeftNavItem {...item} key={key} isActive={item.isActive} />
      ))}
    </>
  );
};
